import dynamic from 'next/dynamic';
import { IPaperSpotProps } from './ipaper-spot';

export const IPaperSpot = dynamic<IPaperSpotProps>(() => import('./ipaper-spot').then((mod) => mod.IPaperSpot), {
    ssr: false,
});
